module.exports = __webpack_public_path__ + "static/img/071.ded6142.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/071.png
// module id = nBFt
// module chunks = 0